// import request from '@/utils/requests'
import axios from './http'

export function excelPurchase(token, params, managerId) {
  return axios({
    method: 'post',
    url: '/api/data-center/report-detail-excel-Purchase',
    headers: {
      'authorization': token,
      'managerId': managerId
    },
    data: params
  })
}

export function putExcel(token, supplierId, params) {
  return axios({
    method: 'post',
    url: '/api/sale/putExcelNewSale',
    headers: {
      'authorization': token,
      'supplierId': supplierId,
      'Content-Type': 'multipart/form-data'
    },
    data: params
  })
}

export function putExtraExcel(token, supplierId, params) {
  return axios({
    method: 'post',
    url: '/api/sale/put-extra-excel',
    headers: {
      'authorization': token,
      'supplierId': supplierId,
      'Content-Type': 'multipart/form-data'
    },
    data: params
  })
}

export function importLabel(token, params) {
  return axios({
    method: 'post',
    url: '/api/sale/importSaleLabel',
    responseType: 'blob',
    headers: {
      'authorization': token,
    },
    data: params
  })
}

export function importLabelPre(token, params) {
  return axios({
    method: 'post',
    url: '/api/sale/importPreSaleLabel',
    responseType: 'blob',
    headers: {
      'authorization': token,
    },
    data: params
  })
}

export function importManager(token, params, managerId) {
  return axios({
    method: 'post',
    url: '/api/sale/importSaleManager',
    responseType: 'blob',
    headers: {
      'authorization': token,
      'managerId': managerId
    },
    data: params
  })
}

export function putManagerExcel(token, supplierId, params) {
  return axios({
    method: 'post',
    url: '/api/sale/put-manager-excel',
    headers: {
      'authorization': token,
      'supplierId': supplierId,
      'Content-Type': 'multipart/form-data'
    },
    data: params
  })
}

export function querySaleExtraPropBySupplier(token, supplierId) {
  return axios({
    method: 'get',
    url: '/api/sale/querySaleExtraPropBySupplier/' + supplierId,
    headers: {
      'authorization': token,
    },
  })
}



export function querySales(token, params) {
  return axios({
    method: 'post',
    url: '/api/sale/getSaleList',
    headers: {
      'authorization': token,
    },
    data: params
  })
}

export function queryPackageInfo(token, params) {
  return axios({
    method: 'post',
    url: '/api/sale/getPackageInfo',
    headers: {
      'authorization': token,
    },
    data: params
  })
}

export function addSaleExtraProp(token, param) {
  return axios({
    method: 'post',
    url: '/api/sale/addSaleExtraProp',
    headers: {
      'authorization': token,
    },
    data: param
  })
}
